export const convertToFormData = (data, keyMapping = {}, nestedKeysToStringify = []) => {
    const formData = new FormData();
  
    const appendToFormData = (obj, parentKey = "") => {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          const mappedKey = keyMapping[key] || key; // Use mapped key if available
          const formKey = parentKey ? `${parentKey}.${mappedKey}` : mappedKey;
  
          if (nestedKeysToStringify.includes(formKey)) {
            // If the key is in the stringify list, stringify it
            formData.append(formKey, JSON.stringify(value));
          } else if (key === "images" && Array.isArray(value)) {
            // Handle images array with file objects
            value.forEach((imageObj, index) => {
              if (imageObj.file) {
                formData.append(`${formKey}[${index}]`, imageObj.file);
              }
            });
          } else if (Array.isArray(value)) {
            // For other arrays, append each item
            value.forEach((item, index) => {
              if (item instanceof File) {
                formData.append(`${formKey}[${index}]`, item);
              } else {
                appendToFormData({ [index]: item }, formKey);
              }
            });
          } else if (typeof value === "object" && value !== null) {
            // If it's an object, recursively append its properties
            appendToFormData(value, formKey);
          } else {
            // For other types (string, number, boolean), append directly
            formData.append(formKey, value);
          }
        }
      }
    };
  
    appendToFormData(data);
    return formData;
  };
  